/* Send the selected fabric to the sample request; studios retain all configuration state. */
(() => {
  'use strict';
  if (window.KaliaProductShortcuts) return;
  const catalogUrl = document.currentScript?.dataset.catalogUrl;
  let catalogRequest;
  const catalog = () => {
    if (!catalogRequest) catalogRequest = fetch(catalogUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(response => { if (!response.ok) throw new Error('Samples unavailable.'); return response.json(); });
    return catalogRequest;
  };
  class KaliaProductShortcuts {
    static selectedSwatch(studio, catalog) {
      if (catalog?.version !== 1 || !Array.isArray(catalog.swatches)) return null;
      const isShade = studio.matches('kalia-product-studio');
      const handle = isShade ? studio.catalog?.handle : studio.dataset.handle;
      if (!handle) return null;
      let matches;
      if (isShade) {
        const names = studio.nativeNames;
        if (!studio.ready || !Array.isArray(names) || !names.length) return null;
        const sources = studio.config?.skus?.filter(sku => names.every(name => typeof studio.nativeChoices?.[name] === 'string' && sku.options?.[name] === studio.nativeChoices[name])) || [];
        if (sources.length !== 1) return null;
        const source = sources[0];
        matches = catalog.swatches.filter(item => item.family !== 'drapery' && item.productHandle === handle && String(item.sourceSkuId) === String(source.id) && Object.keys(item.sourceOptions || {}).length === names.length && names.every(name => item.sourceOptions?.[name] === studio.nativeChoices[name]));
      } else {
        const value = studio.querySelector('input[name="color"]:checked')?.value;
        if (!/^(0|[1-9]\d*)$/.test(value || '')) return null;
        const color = studio.config?.colors?.[Number(value)];
        if (!color || typeof color.label !== 'string') return null;
        matches = catalog.swatches.filter(item => item.family === 'drapery' && item.productHandle === handle && item.sourceOptions?.Color === color.label);
      }
      return matches.length === 1 && typeof matches[0].id === 'string' && /^[A-Za-z0-9][A-Za-z0-9:_-]{0,199}$/.test(matches[0].id) ? matches[0] : null;
    }
    static requestUrl(swatch, base, origin = window.location.origin) {
      if (!swatch || typeof swatch.id !== 'string' || !/^[A-Za-z0-9][A-Za-z0-9:_-]{0,199}$/.test(swatch.id)) return '';
      try {
        const url = new URL(base, origin);
        if (url.origin !== origin || !/\/pages\/free-swatches\/?$/.test(url.pathname)) return '';
        url.search = ''; url.hash = '';
        url.searchParams.set('sample',swatch.id);
        return url.pathname + url.search;
      } catch (_) { return ''; }
    }
    constructor(studio, loadCatalog = catalog) {
      this.studio = studio;
      this.links = [...studio.querySelectorAll('[data-selected-swatch-request]')];
      if (!this.links.length) return;
      this.bases = new Map(this.links.map(link => [link,link.getAttribute('href') || '/pages/free-swatches']));
      this.refresh = this.refresh.bind(this);
      this.onChange = () => queueMicrotask(this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(studio,{childList:true,subtree:true});
      for (const name of ['input','change','kalia:product-studio-ready','kalia:product-configuration-change']) studio.addEventListener(name,this.onChange);
      this.links.forEach(link => link.addEventListener('click',this.refresh));
      this.refresh();
      this.ready = Promise.resolve().then(loadCatalog).then(data => { this.catalog = data; this.refresh(); }).catch(() => this.refresh());
    }
    refresh() {
      const swatch = this.constructor.selectedSwatch(this.studio,this.catalog);
      this.links.forEach(link => {
        const url = swatch ? this.constructor.requestUrl(swatch,this.bases.get(link)) : '';
        const label = url ? 'Get this swatch' : 'Browse swatches';
        const href = url || this.bases.get(link);
        if (link.getAttribute('href') !== href) link.setAttribute('href',href);
        if (link.textContent !== label) link.textContent = label;
        if (url) {
          link.dataset.selectedSwatchId = swatch.id;
          link.setAttribute('aria-label',`Get this swatch: ${swatch.sourceOptions?.Color || swatch.color || swatch.name || swatch.collection || ''}`);
        } else {
          delete link.dataset.selectedSwatchId;
          link.setAttribute('aria-label','Browse swatches');
        }
      });
    }
  }
  window.KaliaProductShortcuts = KaliaProductShortcuts;
  const attached = new WeakSet();
  const start = () => document.querySelectorAll('kalia-product-studio, kalia-drapery').forEach(studio => {
    if (attached.has(studio)) return;
    attached.add(studio); new KaliaProductShortcuts(studio);
  });
  document.addEventListener('shopify:section:load',start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
